import BaseObject from '../../../../base/base_object';
import {SERIVCES_FUNC_LIST, FEATURE_CB_FUNC ,KEY_NAME} from '../../native/native_const';
import {WEB_VIEW_INFO} from './web_view_manager_consts';
import {SYSTEM_EVENTS} from '../../../../events/events';
import Event from '../../../../utils/event';

class BaseWebView extends BaseObject {


    static CLASS = 'BaseWebView';

    _id = -1;
    _type = -1;
    _parent = null;

   init(params) {

       this._id = params.id;
       this._type = params.type;
       this._parent = params.parent;
       super.init();
   }


    /**
     * isValidId
     * return default is false
     */
   isValidId() {
       return false;
   }

    /**
     * getWebId
     * return id of webView
     * MASTER_ID: 0
     * GAME_ID: 1,2,3...999
     * SAFARI_ID: 1000
     */
    getWebId() {
       return this._id;
    }

    /**
     * get the Type of webView
     * return type of web
     * MASTER: 0
     * SECOND: 1
     * SAFARI: 2
     */
    getType() {
        return this._type;
    }

    onclose() {
        this._parent.onclose(this);
    }

    /**
     * set Call back Functions for hybrid
     * each webView has his own cb function with his unique id
     */
    setCbFunctions(hybridService) {
        let data = {[WEB_VIEW_INFO.ID]: this._id, [WEB_VIEW_INFO.TYPE]: this._type};
        hybridService.setCbFunction(SERIVCES_FUNC_LIST.WEB_SECOND_SET_CB, FEATURE_CB_FUNC.HYBRID_WEB_CALL, data);
    }

    /**
     * on Hybrid DirectCall - the call from the hybrid
     * data example: {hybridcbfeaturefunc: "WebViewManagerFeature", webid: "1", action: "https://mirage.navigation-center.com/SharedNavigat…GMxNjctMDdlMy00MjdjLTg4NTItMWVlODZhNzRhZTEz%22%7D"}
     */
    onHybridDirectCall(data) {
        let funcName = 'onHybridCall';
        this[funcName](data);
    }

    /**
     * onHybridCall - call from hybrid
     * data example: {hybridcbfeaturefunc: "WebViewManagerFeature", webid: "0", action: "https://www.google.co.il/"}
     */
    checkOpenLinks(data) {

        try{
            let url = data[KEY_NAME.OPEN_LINK];
            let regex = new RegExp('^(' + [KEY_NAME.BANK_ID] + '|http|https):\\/\\/[^ "]+$');
            let valid = regex.test(url) || url.includes([KEY_NAME.PHONE]);

            const eventData = {category: 'Hybrid_WebView_open', action: 'Open_SecondWebView', label: url}
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, eventData);

            if (true === valid) {
                if(url.toLowerCase().includes(KEY_NAME.MIT_ID) && this._parent.isDepositWidgetSupported()){
                    Event.fire(SYSTEM_EVENTS.WEB_VIEW_NAVIGATE_MIT_ID, 'mitid');
                    const eventData = {category: 'MitId', action: 'MitIdSecondWebViewUrl', label: url}
                    Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, eventData);
                }else {
                    this._parent.openExternalLink(url);
                }
            }else if(0 === url.length){
                if(this._parent.isDepositWidgetSupported()) {
                    Event.fire(SYSTEM_EVENTS.WEB_VIEW_NAVIGATE_DEPOSIT_WIDGET, 'depositWidget');

                    let urlsecondwebview = data[KEY_NAME.URL];

                    //Will Fire only on Android since only in  Android we have the url of the second web view
                    if(urlsecondwebview.length > 0) {
                        this.serviceFactory.analyticsService().sendOrbitUserFlowEvent({
                            category: 'DepositWidget',
                            action: 'DepositWidgetSecondWebViewUrl',
                            label: urlsecondwebview
                        });
                    }
                }
            }else if('CloseWebView' === url){ //We get CloseWebView from Deposit widget to close it
                Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_ALL);
                return;
            }

            this._parent.openLinksAccomplished(this.getWebId(), this.getType());

        }catch (e){
            const eventData = {category: 'Hybrid_WebView_Error', action: 'checkOpenLinks_function', label: e}
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, eventData);
        }

    }
}


export default BaseWebView;